const headerLabels = {
  alert_type_category: 'Categoria',
  alert_type_name: 'Tipo de Alerta',
  created_at: 'Data de criação',
  created_at_hours: 'Hora da criação',
  status: 'Status',
  responsable_type: 'Tipo de responsável',
  responsable_person_name: 'Nome do responsável',
  unified_person_name: 'Nome do cidadão',
  unified_person_birth_certificate_date: 'Data de nascimento do cidadão',
  info_1: 'Info 1',
  info_2: 'Info_2',
  info_3: 'Info_3',
  info_4: 'Info_4',
  info_5: 'Info_5',
  info_6: 'Info_6',
  info_7: 'Info_7',
  places: 'Locais',
}

export default headerLabels
